import { useTranslation } from "react-i18next"
import { translate } from "../../../../../I18n/i18n"
import TruncatedText from "../TruncatedText/TruncatedText"
import './AdvancedShareWithCentersToolbar.scss'

interface AdvancedShareWithCentersToolbarProps {
    selectedOptions: string
    onClick: () => void
}

export default function AdvancedShareWithCentersToolbar({
    selectedOptions,
    onClick
}: AdvancedShareWithCentersToolbarProps) {
    const { t } = useTranslation()

    return (
        <div className="share-option">
            <span className="share-text">
                {translate(t, 'common.TR_SHARE_LABEL')}
            </span>
            <span
                className="share-option-text share-text-clickable"
                onClick={onClick}
            >
                <TruncatedText lines={3}>
                    {selectedOptions.length > 0
                        ? selectedOptions
                        : translate(t, 'common.TR_ALL_LABEL')}
                </TruncatedText>
            </span>
        </div>
    )
}